import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-verify-popup',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './verify-popup.component.html',
  styleUrl: './verify-popup.component.scss',
})
export class VerifyPopupComponent {
  modalRef?: BsModalRef;
  type: string = '';
  isMobile: boolean = false;
  constructor(
    private breakpointObserver: BreakpointObserver,
    private modalService: BsModalService,
    private router: Router
  ) {
    this.breakpointObserver.observe(['(max-width:500px)']).subscribe((result) => {
      this.isMobile = result.matches;
    });
  }
  closeModal() {
    this.modalService.hide();
  }
  doActionTrue() {
    this.modalService.hide();

    if (this.type == 'freelancer') {
      this.router.navigate(['/freelancer/profile/settings/identify-validation']);
    } else {
      this.router.navigate(['/user/profile/settings/identify-validation']);
    }
  }
}
